import {
  EPIC_FIRST_RECORDS,
  formatFirstRecordDate
} from "../../constants/epicFirstRecords";
import { getEpicColor } from "../../utils/epicColors";
import "./epicLeaderboard.css";

type Props = {
  epicName: string;
};

const EpicFirstRecordCard = ({ epicName }: Props) => {
  const record = EPIC_FIRST_RECORDS[epicName];
  if (!record) return null;

  return (
    <div
      className="epic-lb-card epic-lb-first-record"
      style={{ borderLeftColor: getEpicColor(epicName) }}
    >
      <div className="epic-lb-card-title">First recorded result</div>
      <div className="d-flex align-items-baseline flex-wrap gap-2">
        <span className="epic-lb-tile-value">{record.time}</span>
        <span>{record.players.join(", ")}</span>
      </div>
      <div className="epic-lb-muted mt-1">
        Tracking began {formatFirstRecordDate(record.date)}. Earlier runs
        aren't in our data.
      </div>
    </div>
  );
};

export default EpicFirstRecordCard;
